export default __webpack_public_path__ + "static/media/marker-gray-red-orange.46d41637.png";